export const SESSION_TOKEN_KEY = 'session_token';
export const REGION_KEY = 'session_region';
